import clsx from 'clsx'
import { Button } from 'component/Button/Button'
import { Image } from 'component/Image'
import { Radio } from 'component/Radio'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { formatPrice, Item } from 'type/Item'
import css from './ComboCartItem.module.scss'

interface ComboCartItemProps {
  item: Item
  isSelected: boolean
  onSelect: () => void
  onRemove: () => void
}

export const ComboCartItem = observer(
  ({ item, isSelected, onSelect, onRemove }: ComboCartItemProps) => {
    const { show_name, data } = useDemo()
    const { ratio } = data.product  

    const handleCardClick = useLatestCallback(() => {
      onSelect()
    })

    const handleRemoveClick = useLatestCallback(
      (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        onRemove()
      },
    )

    return (
      <div
        className={clsx(css.item, isSelected && css.selected)}
        onClick={handleCardClick}
      >
        <Space>
          <Radio checked={isSelected} onChange={() => onSelect()} />
        </Space>
        <Gap width={12} />
        <Space gap={12} spring oh>
          <Image
            src={item.images?.[0]}
            className={css.itemImage}
            style={{ aspectRatio: ratio }}
          />
          <Vertical gap={show_name ? 0 : 8} spring oh>
            <Typo size={11} line={16} secondary upper>
              {item.brand_name}
            </Typo>
            {show_name && <Space height={32} wide oh>
              <Typo className={css.clamp} size={13} line={16} upper>
                {item.product_name}
              </Typo>
            </Space>}
            <Typo size={13} line={16}>
              {formatPrice(item.prices)}
            </Typo>
          </Vertical>
          <Space>
            <Button compact action={handleRemoveClick} className={css.removeButton}>
              <Icon name="close" size={16} />
            </Button>
          </Space>
        </Space>
      </div>
    )
  },
)
